import React, { useState, Fragment, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  AGENCY_LIST,
  DELETE_USER,
  EMPLOYEE_LIST,
  GET_SINGLE_USER,
  DELETE_AGENCY,
  DECRYPT_PASSWORD_URL,
} from "../../../constants/ApiPaths";
import {
  ADMIN_AGENCY_CREATE_ROUTE,
  ADMIN_AGENCY_DETAILS,
  ADMIN_AGENCY_UPDATE,
} from "../../../constants/RoutePaths";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import Swal from "sweetalert2";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import {
  UncontrolledCollapse,
  Row,
  Col,
  CardBody,
  Input,
  CardTitle,
  Container,
  Collapse,
  Button,
  Card,
  Table,
  Spinner,
  Tooltip,
  FormGroup,
} from "reactstrap";
import ProfileAvatar from "../../../constants/Images/defaultAvatar-1.png";
import { authHeader } from "../../../functions/CoreFunctions";
import { debounce } from "underscore";
import API from "../../../redux/actions/API";
import Pagination from "../../common/Pagination";
import AgencyImage from "../../../constants/Images/defaultAgency-1.png";
import AgencyCustomerModal from "./AgencyCustomerModal";
import { Info } from "../../common/Info";

export default function AdminAgency() {
  const history = useNavigate();
  const [PhoneNumber, setPhoneNumber] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [Email, setEmail] = useState("");
  const [Model, setModel] = useState(false);
  const [SpinLoading, setSpinLoading] = useState(false);
  const [agId, setagId] = useState(0);
  const [Employee, setEmployee] = useState([]);
  const [AgencyName, setAgencyName] = useState("");
  const [totalrecords, setTotalRecords] = useState(0);
  const rowperpage = 10;
  const [currentpage, setCurrentPage] = useState(0);
  const [Emaildisable, setEmaildisable] = useState(false);
  const [flag, setflag] = useState(false);
  const [Count, setCount] = useState(0);
  const [CustomerModal, setCustomerModal] = useState(false);
  const [employeetotal, setemployeetotal] = useState("");
  const [employeePage, setemployeePage] = useState(0);
  const [oldPassword, setOldpassword] = useState();
  const [lookupMail, setLookupMail] = useState();

  // const [passwordhide, setPasswordHide] = useState(true);
  const [passwordHide, setPasswordHide] = useState(Employee.map(() => true));
  const initialValues = {
    firstName: "",
    email: "",
    lastName: "",
    phoneNumber: "+1 ",
    roleId: 3,
    city: "",
    hyperlink: window.location.origin,
    stateId: null,
    gender: "",
    dateOfBirth: "",
    profileImage: "",
    address: "",
    zip: "",
    agencyId: agId,
    password: "",
  };
  const [formdata, setformData] = useState(initialValues);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [AgId, setAgId] = useState(0);
  const [id, setid] = useState("");
  const toggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const CustomerModalToogle = (e) => {
    if (e) {
      setAgId(e.currentTarget.dataset.agencyid);
    }
    setEmaildisable(false);
    setformData(initialValues);
    setLookupMail("");
    setflag(true);
    setCustomerModal(!CustomerModal);
  };
  const Agency_create = () => {
    history(ADMIN_AGENCY_CREATE_ROUTE);
  };
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const onEmployeePageChange = (page) => {
    setemployeePage(page - 1);
  };

  //no
  //define state
  const [list, setList] = useState([]);
  const [Loading, setLoading] = useState(false);

  const callList = useCallback(
    async (AgencyName, PhoneNumber, Email, offset, count) => {
      setLoading(true);
      const config = {
        method: "GET",
        url: AGENCY_LIST,
        headers: authHeader(),
        params: {
          offset,
          count,
          email: Email,
          agencyName: AgencyName,
          phoneNumber: PhoneNumber,
        },
      };
      try {
        const response = await API(config);
        const { status, totalCount } = response.data;
        if (status === "Success") {
          const { data } = response.data;
          setList(data);
          setTotalRecords(totalCount);
        }
      } catch (error) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      } finally {
        setLoading(false);
      }
    },
    [enqueueSnackbar]
  );

  const DeleteAlert = (e) => {
    const id = e.currentTarget.dataset.agencyid;
    Swal.fire({
      title: "Are you sure?",
      text: "Are You Want to Delete this Agency!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteAgency(id);
      }
    });
  };

  const DeleteAgency = async (id) => {
    setLoading(true);
    const config = {
      method: "DELETE",
      url: DELETE_AGENCY,
      headers: authHeader(),
      params: {
        agencyId: id,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        callList();
        FilterReset();
        CustomAlertMessage(
          "Agency Deleted Successful",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      const { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };

  const onHandlePhoneNumber = (e) => {
    const { value } = e.target;
    setPhoneNumber(value);
  };
  const onHandleEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
  };
  const onHandleAgencyName = (e) => {
    const { value } = e.target;
    setAgencyName(value);
  };

  const AgencyProfile = (agencyLogo) => {
    if (agencyLogo) {
      return <img src={agencyLogo} alt="src" />;
    } else {
      return <img src={AgencyImage} alt="src" />;
    }
  };

  const FilterReset = () => {
    setAgencyName("");
    setEmail("");
    setPhoneNumber("");
  };

  const delaySearch = useCallback(
    debounce((AgencyName, PhoneNumber, Email) => {
      callList(AgencyName, PhoneNumber, Email, currentpage, rowperpage);
    }, 500),
    [callList, currentpage, rowperpage]
  );

  // Trigger search on changes
  useEffect(() => {
    delaySearch(AgencyName, PhoneNumber, Email);
  }, [PhoneNumber, AgencyName, Email, delaySearch]);

  // Trigger the initial list load or when pagination changes
  useEffect(() => {
    callList(AgencyName, PhoneNumber, Email, currentpage, rowperpage);
  }, [currentpage, rowperpage, AgencyName, PhoneNumber, Email, callList]);

  const hideFun = async (index) => {
    togglePasswordVisibility(index);
  };
  const ListUser = (e) => {
    const ID = e.currentTarget.dataset.agencyid;

    if (parseInt(ID) === parseInt(agId)) {
      setModel(!Model);
    } else {
      setModel(true);
    }
    setagId(ID);
  };

  const DeleteEmployee = async (ID) => {
    setSpinLoading(true);
    const config = {
      method: "DELETE",
      url: DELETE_USER,
      headers: authHeader(),
      params: {
        userId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        setCount(Count + 1);
        setSpinLoading(false);
        CustomAlertMessage(
          "Employee Deleted Sucessfully!",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSpinLoading(false);
    }
  };

  function DeleteDeteils(e) {
    const ID = e.currentTarget.dataset.userid;
    Swal.fire({
      title: "Are you sure?",
      text: "Are You Want to Delete this Employee!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteEmployee(ID);
      }
    });
  }
  const getDecrypted = async (password) => {
    const config = {
      method: "POST",
      headers: authHeader(),
      url: DECRYPT_PASSWORD_URL,
      data: {
        encrypt: password,
      },
    };
    try {
      const response = await API(config);
      if (response) {
        // ps = response.data;
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const decryptPasswords = useCallback(async (data) => {
    try {
      const decryptedData = await Promise.all(
        data.map(async (item) => {
          const decryptedPassword = await getDecrypted(item.password);
          return { ...item, password: decryptedPassword };
        })
      );

      return decryptedData;
    } catch (error) {
      console.error(error);
      // Handle error if needed
    }
  }, []);
  const copyPasswordFun = async (pass) => {
    try {
      await navigator.clipboard.writeText(pass);
      CustomAlertMessage(
        "Password copied to clipboard",
        "success",
        enqueueSnackbar
      );
    } catch (err) {
      CustomAlertMessage(
        "Unable to copy password to clipboard",
        "error",
        enqueueSnackbar
      );
    }
  };
  const UpdateUser = async (e) => {
    setLookupMail("");
    setEmaildisable(true);
    setCustomerModal(!CustomerModal);
    setflag(false);
    const ID = e.currentTarget.dataset.userid;
    const config = {
      method: "GET",
      url: GET_SINGLE_USER,
      headers: authHeader(),
      params: {
        userId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        const decryptedPassword = await getDecrypted(data.password);
        data.password = decryptedPassword;
        setOldpassword(data.password);
        setformData({ ...data, phoneNumber: "+1 ".concat(data.phoneNumber) });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const GetEmployee = async () => {
      setSpinLoading(true);
      const config = {
        method: "GET",
        url: EMPLOYEE_LIST,
        headers: authHeader(),
        params: {
          agencyId: agId,
          roleId: "3, 4",
          offset: employeePage,
        },
      };
      try {
        const response = await API(config);
        const { status, data, totalCount } = response.data;
        if (status === "Success") {
          setemployeetotal(totalCount);
          const d1 = data && (await decryptPasswords(data));

          setEmployee(d1);
          setPasswordHide(d1.map(() => true));
          setSpinLoading(false);
        }
      } catch (error) {
      } finally {
        setSpinLoading(false);
      }
    };
    GetEmployee();
  }, [agId, employeePage, Count, decryptPasswords]);
  const togglePasswordVisibility = (index) => {
    // Create a copy of the array and toggle the state for the specified row
    const newPasswordHide = [...passwordHide];
    newPasswordHide[index] = !newPasswordHide[index];
    setPasswordHide(newPasswordHide);
  };
  return (
    <div>
      {Loading && <CustomPageLoading />}
      <div className="wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>
              Agency{" "}
              <Tooltip
                isOpen={"id" + 1 === id && tooltipOpen}
                target={"id" + 1}
                toggle={() => toggle("id" + 1)}
              >
                View list of registered agencies
              </Tooltip>
              <span id={"id" + 1}>
                <Info />
              </span>{" "}
            </h4>

            <div className="top-btn">
              <Button color="link" id="toggler">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>

              <Button onClick={Agency_create} color="primary">
                <svg
                  className="mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.401"
                  height="12.402"
                  viewBox="0 0 12.401 12.402"
                >
                  <g
                    id="Icon_feather-plus"
                    data-name="Icon feather-plus"
                    transform="translate(-6.6 -6.6)"
                  >
                    <path
                      id="Path_82"
                      data-name="Path 82"
                      d="M18,7.5V18.1"
                      transform="translate(-5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                    <path
                      id="Path_83"
                      data-name="Path 83"
                      d="M7.5,18H18.1"
                      transform="translate(0 -5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                  </g>
                </svg>
                Create New Agency
              </Button>
            </div>
          </div>

          <UncontrolledCollapse toggler="#toggler" className="mt-4">
            <Card>
              <CardBody>
                <Row>
                  <Col md="6" lg="3" xl="3">
                    <FormGroup>
                      <span>Search Agency Name</span>
                      <Input
                        type="text"
                        onChange={onHandleAgencyName}
                        value={AgencyName}
                        name="AgencyName"
                        placeholder="Search Agency Name"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="3" xl="3">
                    <FormGroup>
                      <span>Search Email</span>
                      <Input
                        type="text"
                        onChange={onHandleEmail}
                        value={Email}
                        name="Email"
                        placeholder="Search Email"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="3" xl="3">
                    <FormGroup>
                      <span>Search Phone Number</span>
                      <Input
                        type="text"
                        onChange={onHandlePhoneNumber}
                        value={PhoneNumber}
                        name="PhoneNumber"
                        placeholder="Search Phone Number"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="3" xl="3">
                    <Button
                      color="danger"
                      onClick={FilterReset}
                      className="mt-4"
                    >
                      Clear
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
          {/* table */}

          <Card body className="mt-4">
            <Table hover responsive className="d-agency">
              <thead>
                <tr>
                  <th> Logo</th>
                  <th> Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Action</th>
                </tr>
              </thead>

              {Loading ? (
                ""
              ) : list.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan={5}>
                      <center>No Record Found</center>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {list.map((agency) => {
                    const {
                      agencyId,
                      agencyName,
                      agencyLogo,
                      agencyEmail,
                      phoneNumber,
                      isDeleted,
                    } = agency;
                    return (
                      <Fragment>
                        <tr key={agencyId}>
                          <td>
                            <div className="user-box">
                              {AgencyProfile(agencyLogo)}
                            </div>
                          </td>
                          <td>{agencyName}</td>
                          <td>{agencyEmail}</td>
                          <td>{phoneNumber ? `+1 ${phoneNumber}` : ""}</td>
                          <td>
                            <Button
                              className="table-btn"
                              onClick={ListUser}
                              disabled={isDeleted}
                              data-agencyid={agencyId}
                              color="link"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16.71"
                                height="12.15"
                                viewBox="0 0 19.841 14.43"
                              >
                                <path
                                  id="Icon_material-person-add"
                                  data-name="Icon material-person-add"
                                  d="M14.126,13.215a3.608,3.608,0,1,0-3.608-3.608A3.607,3.607,0,0,0,14.126,13.215Zm-8.117-1.8V8.706h-1.8v2.706H1.5v1.8H4.206v2.706h1.8V13.215H8.715v-1.8Zm8.117,3.608c-2.408,0-7.215,1.209-7.215,3.608v1.8h14.43v-1.8C21.341,16.227,16.534,15.019,14.126,15.019Z"
                                  transform="translate(-1.5 -6)"
                                  fill="#1b3e6f"
                                />
                              </svg>
                            </Button>

                            <Link to={`${ADMIN_AGENCY_DETAILS}/${agencyId}`}>
                              <Button className="table-btn" color="link">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16.216"
                                  height="10.811"
                                  viewBox="0 0 16.216 10.811"
                                >
                                  <path
                                    id="Icon_awesome-eye"
                                    data-name="Icon awesome-eye"
                                    d="M16.118,9.494A9.03,9.03,0,0,0,8.108,4.5,9.031,9.031,0,0,0,.1,9.495a.911.911,0,0,0,0,.822,9.03,9.03,0,0,0,8.01,4.994,9.031,9.031,0,0,0,8.01-4.995A.911.911,0,0,0,16.118,9.494Zm-8.01,4.465a4.054,4.054,0,1,1,4.054-4.054A4.054,4.054,0,0,1,8.108,13.959Zm0-6.757a2.683,2.683,0,0,0-.713.107A1.347,1.347,0,0,1,5.512,9.193a2.7,2.7,0,1,0,2.6-1.99Z"
                                    transform="translate(0 -4.5)"
                                    fill="#1b3e6f"
                                  />
                                </svg>
                              </Button>
                            </Link>
                            {!isDeleted && (
                              <Link to={`${ADMIN_AGENCY_UPDATE}/${agencyId}`}>
                                <Button className="table-btn" color="link">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10.928"
                                    height="10.928"
                                    viewBox="0 0 10.928 10.928"
                                  >
                                    <path
                                      id="Icon_material-mode-edit"
                                      data-name="Icon material-mode-edit"
                                      d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                                      transform="translate(-4.5 -4.496)"
                                      // fill="#fff"
                                    />
                                  </svg>
                                </Button>
                              </Link>
                            )}
                            {!isDeleted && (
                              <Button
                                onClick={DeleteAlert}
                                data-agencyid={agencyId}
                                className="table-btn"
                                color="danger"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10.236"
                                  height="13.161"
                                  viewBox="0 0 10.236 13.161"
                                >
                                  <path
                                    id="Icon_material-delete"
                                    data-name="Icon material-delete"
                                    d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                                    transform="translate(-7.5 -4.5)"
                                    fill="#fff"
                                  />
                                </svg>
                              </Button>
                            )}
                          </td>
                        </tr>
                        <tr className="agency-elist">
                          <td colSpan={5}>
                            <Collapse
                              isOpen={
                                Model && parseInt(agId) === parseInt(agencyId)
                              }
                            >
                              <Card className="tableInnercard">
                                <CardTitle tag="h5" className="d-flex">
                                  Agency Admin List
                                  <Tooltip
                                    isOpen={id === "id" + 2 && tooltipOpen}
                                    target={"id" + 2}
                                    toggle={() => toggle("id" + 2)}
                                  >
                                    List of registered agencies
                                  </Tooltip>
                                  <span id={"id" + 2}>
                                    <Info />
                                  </span>
                                  <Button
                                    onClick={CustomerModalToogle}
                                    data-agencyid={agencyId}
                                    color="primary"
                                    className="ml-auto d-block"
                                  >
                                    <svg
                                      className="mr-3"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12.401"
                                      height="12.402"
                                      viewBox="0 0 12.401 12.402"
                                    >
                                      <g
                                        id="Icon_feather-plus"
                                        data-name="Icon feather-plus"
                                        transform="translate(-6.6 -6.6)"
                                      >
                                        <path
                                          id="Path_82"
                                          data-name="Path 82"
                                          d="M18,7.5V18.1"
                                          transform="translate(-5.199)"
                                          fill="none"
                                          stroke="#fff"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="1.8"
                                        />
                                        <path
                                          id="Path_83"
                                          data-name="Path 83"
                                          d="M7.5,18H18.1"
                                          transform="translate(0 -5.199)"
                                          fill="none"
                                          stroke="#fff"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="1.8"
                                        />
                                      </g>
                                    </svg>
                                    New Agency Admin
                                  </Button>
                                </CardTitle>

                                <CardBody>
                                  <Table>
                                    <thead>
                                      <tr>
                                        <th>Profile</th>
                                        <th>Name</th>
                                        <th>Mobile Number</th>
                                        <th>Email</th>
                                        <th>Password</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {SpinLoading ? (
                                        <tr>
                                          {" "}
                                          <td colSpan={5}>
                                            <center>
                                              <Spinner></Spinner>
                                            </center>
                                          </td>
                                        </tr>
                                      ) : Employee.length === 0 ? (
                                        <tr>
                                          <td colSpan={5}>
                                            <center>No Record Found</center>
                                          </td>
                                        </tr>
                                      ) : (
                                        <>
                                          {Employee.map((i, index) => (
                                            <tr>
                                              <td>
                                                {" "}
                                                <div className="user-box">
                                                  <img
                                                    src={
                                                      i.profileImage === ""
                                                        ? ProfileAvatar
                                                        : i.profileImage
                                                    }
                                                    alt=""
                                                  />
                                                </div>
                                              </td>
                                              <td>
                                                {i.firstName} {i.lastName}
                                              </td>
                                              <td>
                                                {i.phoneNumber
                                                  ? `+1 ${i.phoneNumber}`
                                                  : ""}
                                              </td>
                                              <td>{i.email}</td>
                                              <td>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      paddingTop: "16px",
                                                    }}
                                                  >
                                                    {passwordHide[index] ===
                                                      true && i.password
                                                      ? "*".repeat(
                                                          i.password.length
                                                        )
                                                      : i.password}
                                                    {/* {renderPassword(i.userId, i.password)} */}
                                                  </p>
                                                  <Button
                                                    onClick={() => {
                                                      copyPasswordFun(
                                                        i.password
                                                      );
                                                    }}
                                                    className="btn-secondary-cr pass-btn"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="20"
                                                      height="20"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M14.0125 3.28125H7.78125C7.36685 3.28125 6.96942 3.44587 6.6764 3.7389C6.38337 4.03192 6.21875 4.42935 6.21875 4.84375V13.375C6.21875 13.7894 6.38337 14.1868 6.6764 14.4799C6.96942 14.7729 7.36685 14.9375 7.78125 14.9375H14.0125C14.4269 14.9375 14.8243 14.7729 15.1174 14.4799C15.4104 14.1868 15.575 13.7894 15.575 13.375V4.83125C15.5717 4.41902 15.4056 4.02479 15.113 3.73447C14.8203 3.44414 14.4247 3.28124 14.0125 3.28125ZM14.6375 13.375C14.6375 13.5408 14.5717 13.6997 14.4544 13.8169C14.3372 13.9342 14.1783 14 14.0125 14H7.78125C7.61549 14 7.45652 13.9342 7.33931 13.8169C7.2221 13.6997 7.15625 13.5408 7.15625 13.375V4.83125C7.15625 4.66549 7.2221 4.50652 7.33931 4.38931C7.45652 4.2721 7.61549 4.20625 7.78125 4.20625H14.0125C14.1783 4.20625 14.3372 4.2721 14.4544 4.38931C14.5717 4.50652 14.6375 4.66549 14.6375 4.83125V13.375Z"
                                                        fill="#3D3D3D"
                                                      />
                                                      <path
                                                        d="M12.2093 15.7813H5.99365C5.82789 15.7813 5.66892 15.7154 5.55171 15.5982C5.4345 15.481 5.36865 15.322 5.36865 15.1563V6.6344C5.36865 6.51008 5.31927 6.39085 5.23136 6.30294C5.14345 6.21504 5.02422 6.16565 4.8999 6.16565C4.77558 6.16565 4.65635 6.21504 4.56845 6.30294C4.48054 6.39085 4.43115 6.51008 4.43115 6.6344V15.1594C4.43115 15.5738 4.59577 15.9712 4.8888 16.2643C5.18182 16.5573 5.57925 16.7219 5.99365 16.7219H12.2093C12.334 16.7219 12.4536 16.6723 12.5418 16.5841C12.63 16.4959 12.6796 16.3763 12.6796 16.2516C12.6796 16.1269 12.63 16.0072 12.5418 15.919C12.4536 15.8308 12.334 15.7813 12.2093 15.7813Z"
                                                        fill="#3D3D3D"
                                                      />
                                                    </svg>
                                                  </Button>
                                                  <Button
                                                    data={i.userId}
                                                    onClick={() =>
                                                      hideFun(index)
                                                    }
                                                    className="btn-secondary-cr"
                                                  >
                                                    {passwordHide[index] ===
                                                    true ? (
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M12.1082 7.89172L7.8916 12.1084C7.34994 11.5667 7.0166 10.825 7.0166 10C7.0166 8.35002 8.3499 7.01672 9.9999 7.01672C10.8249 7.01672 11.5666 7.35006 12.1082 7.89172Z"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M14.8499 4.80834C13.3916 3.70834 11.7249 3.10834 9.99989 3.10834C7.0582 3.10834 4.31654 4.84167 2.4082 7.84167C1.6582 9.01669 1.6582 10.9917 2.4082 12.1667C3.06654 13.2 3.8332 14.0917 4.66654 14.8084"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M7.0166 16.2751C7.9666 16.6751 8.9749 16.8918 9.9999 16.8918C12.9416 16.8918 15.6832 15.1584 17.5916 12.1584C18.3416 10.9834 18.3416 9.00844 17.5916 7.8334C17.3166 7.40007 17.0166 6.99173 16.7082 6.6084"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M12.925 10.5833C12.7083 11.7583 11.75 12.7166 10.575 12.9333"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M7.89175 12.1083L1.66675 18.3333"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M18.3334 1.66669L12.1084 7.89169"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                      </svg>
                                                    ) : (
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M12.9833 10.0001C12.9833 11.6501 11.6499 12.9834 9.99993 12.9834C8.34993 12.9834 7.0166 11.6501 7.0166 10.0001C7.0166 8.35006 8.34993 7.01672 9.99993 7.01672C11.6499 7.01672 12.9833 8.35006 12.9833 10.0001Z"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M10.0001 16.8916C12.9418 16.8916 15.6834 15.1583 17.5918 12.1583C18.3418 10.9833 18.3418 9.00831 17.5918 7.83331C15.6834 4.83331 12.9418 3.09998 10.0001 3.09998C7.05845 3.09998 4.31678 4.83331 2.40845 7.83331C1.65845 9.00831 1.65845 10.9833 2.40845 12.1583C4.31678 15.1583 7.05845 16.8916 10.0001 16.8916Z"
                                                          stroke="#3D3D3D"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                      </svg>
                                                    )}
                                                  </Button>
                                                </div>
                                              </td>
                                              <td>
                                                {" "}
                                                <div className="action-btn">
                                                  <Button
                                                    className="editBtn"
                                                    data-userid={i.userId}
                                                    onClick={UpdateUser}
                                                    color="link"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="10.928"
                                                      height="10.928"
                                                      viewBox="0 0 10.928 10.928"
                                                    >
                                                      <path
                                                        id="Icon_material-mode-edit"
                                                        data-name="Icon material-mode-edit"
                                                        d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                                                        transform="translate(-4.5 -4.496)"
                                                        fill="#fff"
                                                      />
                                                    </svg>
                                                  </Button>
                                                  <Button
                                                    onClick={DeleteDeteils}
                                                    data-userid={i.userId}
                                                    className="deleteBtn"
                                                    color="link"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="10.236"
                                                      height="13.161"
                                                      viewBox="0 0 10.236 13.161"
                                                    >
                                                      <path
                                                        id="Icon_material-delete"
                                                        data-name="Icon material-delete"
                                                        d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                                                        transform="translate(-7.5 -4.5)"
                                                        fill="#fff"
                                                      />
                                                    </svg>
                                                  </Button>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}{" "}
                                        </>
                                      )}
                                    </tbody>
                                  </Table>
                                  <div className="d-flex flex-row py-4 justify-content-end">
                                    <Pagination
                                      itemClass="page-item"
                                      linkClass="page-link"
                                      activePage={employeePage + 1}
                                      itemsCountPerPage={10}
                                      totalItemsCount={employeetotal}
                                      onChange={onEmployeePageChange}
                                    />
                                  </div>
                                </CardBody>
                              </Card>
                            </Collapse>
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
                </tbody>
              )}
            </Table>
            <div className="d-flex flex-row py-4 justify-content-end">
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={currentpage + 1}
                itemsCountPerPage={rowperpage}
                totalItemsCount={totalrecords}
                onChange={onPageChange}
              />
            </div>
          </Card>
        </Container>
      </div>
      <AgencyCustomerModal
        Emaildisable={Emaildisable}
        flag={flag}
        setflag={setflag}
        setformData={setformData}
        oldPassword={oldPassword}
        CustomerModal={CustomerModal}
        setCount={setCount}
        formdata={formdata}
        Count={Count}
        CustomerModalToogle={CustomerModalToogle}
        agencyId={agId}
        lookupMail={lookupMail}
        setLookupMail={setLookupMail}
      />
    </div>
  );
}
